import { render, staticRenderFns } from "./AppNotifications.vue?vue&type=template&id=5877ecae&"
import script from "./AppNotifications.vue?vue&type=script&lang=js&"
export * from "./AppNotifications.vue?vue&type=script&lang=js&"
import style0 from "./AppNotifications.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports